// extracted by mini-css-extract-plugin
export default {"overlay":"OverlayLoader_overlay__M3f7M","loader":"OverlayLoader_loader__T4AmC","ball":"OverlayLoader_ball__zxPDp","bounce":"OverlayLoader_bounce__o1X74"};